import { createSlice } from '@reduxjs/toolkit';

import { ViewResponse } from '../../models/viewResponse/ViewResponse';

const initialState = {} as ViewResponse;

const FormConfigSlice = createSlice({
  name: 'FormConfigState',
  initialState,
  reducers: {
    setFromConfigState(_, action) {
      return action.payload;
    },
  },
});

export const { setFromConfigState } = FormConfigSlice.actions;

const FormConfigReducer = FormConfigSlice.reducer;

export default FormConfigReducer;